export const queryParamsToPreserve = [
  'attributes',
  'cms',
  'disableOptimizely',
  'enrollment_marketing_source',
  'espot',
  'preview',
  'cmsSiteId',
]

/**
 * This middleware is used to preserve content query parameters when navigating between pages.
 * cmsSiteId - The ID of the site to fetch content from (timberland-en-150, timberland-en-us, timberland-showcase-en-us, etc.)
 * cms - The CMS environment to fetch content from (dev, qa, uat, prod). Handled by Akamai
 * preview - A flag to enable preview mode.
 * enrollment_marketing_source - Passing campaignName for promotions tracking in OCP
 * espot - The flag to highlight CMS espots
 * attributes - The flag to show product content attributes on PDP
 * disableOptimizely - Disables Optimizely integrations for the session URL:
 *   `web` (Web only), `fx` (Feature Experimentation only), `true` (both), `false` (neither, same as omitted)
 */
export default defineNuxtRouteMiddleware((to, from) => {
  const toPreserve = queryParamsToPreserve
    .filter((name) => from.query[name] && !to.query[name])
    .map((name) => [name, from.query[name]])

  if (!toPreserve.length) return

  return navigateTo({
    path: to.path,
    query: {
      ...to.query,
      ...Object.fromEntries(toPreserve)
    },
    hash: to.hash
  })
})
